// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-row[data-v-e298b0d8] {\n  display: flex;\n  margin-top: 6px;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.margin-left-6[data-v-e298b0d8] {\n  margin-left: 6px;\n}\n.fontsize-16[data-v-e298b0d8] {\n  font-size: 16px;\n}\n.min-width-178[data-v-e298b0d8] {\n  min-width: 178px;\n}\n", ""]);
// Exports
module.exports = exports;
